//fixes bug with looped video autoplay on iOS devices. version 1.0.0

export default function videoPlaysInline() {
  $( window ).on("load", function() {
    $("video").attr("playsinline", "");
  });
}